import { cn } from "@omni/utils/styles";

type TitleProps = {
    title: string;
    lines?: 1 | 2 | 3 | 4 | 5;
    className?: string;
};

const ProductTitle = ({ title, lines = 2, className }: TitleProps) => {
    return (
        <div
            className={cn(
                "tw:text-primary tw:my-0 tw:leading-[1.2rem]",
                {
                    "tw:line-clamp-1 tw:h-[1.2rem]": lines === 1,
                    "tw:line-clamp-2 tw:h-[2.4rem]": lines === 2,
                    "tw:line-clamp-3 tw:h-[3.6rem]": lines === 3,
                    "tw:line-clamp-4 tw:h-[4.8rem]": lines === 4,
                    "tw:line-clamp-5 tw:h-24": lines === 5
                },
                className
            )}
        >
            {title}
        </div>
    );
};

export default ProductTitle;
